import { type MouseEvent, useState } from 'react'

import { ButtonDefault } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { CONTENT_WARNING_URL } from '@/defs/misc'

import styles from './CardFaceWarning.module.scss'

export const CardFaceWarning = () => {
  const [showWarning, setShowWarning] = useState(true)

  const onClickWarning = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setShowWarning(false)
  }

  return (
    showWarning && (
      <div className={styles.container} onClick={(e) => e.stopPropagation()}>
        <p className={styles.icon}>
          <Icon name='circleExclamation' />
        </p>
        <p className={styles.note}>
          <strong>Please note:</strong> This card is not in compliance with Magic&apos;s community standards as a result
          of racist artwork or text, the use of demographic stereotypes, and/or parallels to sensitive historical
          events.
        </p>
        <div className={styles.buttons}>
          <ButtonDefault onClick={onClickWarning}>Show Card Image</ButtonDefault>
          <ButtonDefault as='LinkOutbound' href={CONTENT_WARNING_URL} onClick={(e) => e.stopPropagation()}>
            More Info
          </ButtonDefault>
        </div>
      </div>
    )
  )
}
